import styled from "styled-components";
import {ListTitleTextDefaultBox} from "./list-title-text.default.box";

export const ListTitleTextWsopBox = styled(ListTitleTextDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.lAndAbove } {
    min-width: 40rem;
  }
`